import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setProgressBarCurrentStep } from '@avalara/bat-apps-shared/client/actions/progress-bar';
import { useHistory } from 'react-router-dom';
import { setCurrentOfferPage } from '../../store/offer';
import { stepNames } from '../../lib/side-effects/progress-bar';
import { goToNextOfferStep } from '../../lib/side-effects/offer-flow';
import SelectConnector from '../../containers/shared/connectors/select-connector';
import { Pages } from '../../../shared/types/offers';
import { selectState } from '../../selectors';
import { selectConnector } from '../../lib/side-effects/connectors';
import { setConnectorValidationStatus } from '../../store/order';
const SelectConnectorContainer = () => {
    const dispatch = useDispatch();
    const state = useSelector(selectState);
    const history = useHistory();
    useEffect(() => {
        dispatch(setCurrentOfferPage(Pages.SelectConnector));
        dispatch(setProgressBarCurrentStep(stepNames.selectConnector));
    }, []);
    const onSelectConnector = () => {
        var _a;
        dispatch(selectConnector(((_a = state.avataxSignup.selectedConnector) === null || _a === void 0 ? void 0 : _a.id) || ''));
        dispatch(setConnectorValidationStatus(true));
        dispatch(goToNextOfferStep({ history }));
    };
    return React.createElement(SelectConnector, { onSelectConnector: onSelectConnector, isBannerHidden: true });
};
export default SelectConnectorContainer;
